import { render, staticRenderFns } from "./Note-legali.vue?vue&type=template&id=144f0923&scoped=true&"
import script from "./Note-legali.vue?vue&type=script&lang=js&"
export * from "./Note-legali.vue?vue&type=script&lang=js&"
import style0 from "./Note-legali.vue?vue&type=style&index=0&id=144f0923&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144f0923",
  null
  
)

export default component.exports